import { useEffect, useMemo, useState } from 'react';

import { Bets } from '../../../config/bets';
import { useCrashAutoplaySlice } from '../../../store/slices/crashAutoplay/selectors';
import { useHighflyerGameStateSlice } from '../../../store/slices/highflyerGame/selectors';
import { useHighflyerStateSlice } from '../../../store/slices/highflyerState/selectors';

export const useBetboardCanBeHidden = (): Bets | null => {
  const isBetPlacedOnBetboardOne = useHighflyerStateSlice.isBetPlaced(Bets.ONE);
  const isBetPlacedOnBetboardTwo = useHighflyerStateSlice.isBetPlaced(Bets.TWO);
  const isAutoPlayEnabledForBetboardOne = useCrashAutoplaySlice.isInProgress(Bets.ONE);
  const isAutoPlayEnabledForBetboardTwo = useCrashAutoplaySlice.isInProgress(Bets.TWO);
  const areTwoBetBoardsDisplayed = useHighflyerGameStateSlice.getIsSecondBetBoardToggle();
  const [previousValue, setPreviousValue] = useState<Bets | null>(null);

  const currentValue = useMemo(() => {
    //When Both betboards has bet
    if (isBetPlacedOnBetboardOne && isBetPlacedOnBetboardTwo) return null;

    //When Both betboards has autoplay in progress
    if (isAutoPlayEnabledForBetboardOne && isAutoPlayEnabledForBetboardTwo) return null;

    if (isAutoPlayEnabledForBetboardOne) {
      return isBetPlacedOnBetboardTwo ? null : Bets.TWO;
    }

    if (isAutoPlayEnabledForBetboardTwo) {
      return isBetPlacedOnBetboardOne ? null : Bets.ONE;
    }

    if (isBetPlacedOnBetboardOne) return Bets.TWO;

    if (isBetPlacedOnBetboardTwo) return Bets.ONE;

    return Bets.TWO;
  }, [
    isAutoPlayEnabledForBetboardOne,
    isAutoPlayEnabledForBetboardTwo,
    isBetPlacedOnBetboardOne,
    isBetPlacedOnBetboardTwo,
  ]);

  useEffect(() => {
    //When either of betboards is displayed then take itself as a priority rather than second betboard
    if (!areTwoBetBoardsDisplayed && previousValue !== null) {
      return;
    }
    setPreviousValue(currentValue);
  }, [currentValue, areTwoBetBoardsDisplayed, previousValue]);

  return previousValue;
};
